import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { sendEvent } from '../services/user-interaction.service';
import { ANALYTICS_EVENTS } from '../shared/constants/events';
import useIsMobile from './useIsMobile';
import useClarityEvent from './useClarityEvent';

interface UsePageViewProps {
	sectionVisit: string;
	isHomePage?: boolean;
}

const usePageView = ({
	sectionVisit,
	isHomePage = false,
}: UsePageViewProps) => {
	const { trackEvent } = useClarityEvent();
	const isMobile = useIsMobile();
	const { status } = useSelector((state: RootState) => state.satLinkStatus);
	const { user: userProfile } = useSelector(
		(state: RootState) => state.profile,
	);

	const trackPageView = useCallback(async () => {
		if (!userProfile?.id) return;

		try {
			const eventPayload = {
				section_visit: sectionVisit,
				...(isHomePage && { is_linked: status?.status === 'ACTIVE' }),
			};

			await sendEvent({
				user_id: userProfile.id,
				event: ANALYTICS_EVENTS.PAGE_VIEW,
				source: isMobile ? 'app' : 'web',
				event_payload: eventPayload,
			});

			trackEvent(sectionVisit);
		} catch (error) {}
	}, []);

	return { trackPageView };
};

export default usePageView;
